module.exports = __webpack_public_path__ + "img/logo-sekolah-an-nisaa.983d2cb6.png";